var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorIcon = function SvgErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16 2.667a13.334 13.334 0 1 1 0 26.667 13.334 13.334 0 0 1 0-26.667m0 24.762a11.428 11.428 0 1 0 0-22.857 11.428 11.428 0 0 0 0 22.857M15.048 8.38h1.905v10.477h-1.905zm1.746 13.574a1.428 1.428 0 1 0-1.587 2.375 1.428 1.428 0 0 0 1.587-2.375",
    clipRule: "evenodd"
  })));
};
export { SvgErrorIcon as Icon };
export default __webpack_public_path__ + "static/media/dc6d006ad72593a1fd4885a3735d4bd8.svg";